'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { MARKETING_APP_HREF } from '@/components/landing/marketingAppHref'

type MarketingOpenWagamourButtonProps = {
  label?: string
  size?: 'sm' | 'md' | 'lg'
  showIcon?: boolean
  className?: string
  heroAnalyticsCtaId?: string
}

const v2MarketingCtaClassName =
  'inline-flex h-14 min-w-[min(100%,220px)] items-center justify-center gap-2 rounded-full border-0 bg-[linear-gradient(90deg,#FF8A65,#FF7FA4,#F6B443)] px-8 text-base font-bold text-white shadow-[0_12px_40px_rgba(255,127,164,0.25)] transition-transform hover:scale-[1.02] hover:brightness-[1.04] active:scale-[0.99] sm:min-w-[260px]'

export function MarketingOpenWagamourButton({
  label = 'Open Wagamour',
  showIcon = true,
  className,
}: MarketingOpenWagamourButtonProps) {
  return (
    <Link
      href={MARKETING_APP_HREF}
      className={cn(v2MarketingCtaClassName, className)}
    >
      <span>{label}</span>
      {showIcon ? <ArrowRight className="h-4 w-4" aria-hidden /> : null}
    </Link>
  )
}
